import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Logo from '../components/Logo';



const ForgotPasswordPage = () => {
  const { requestPasswordReset } = useAuth();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await requestPasswordReset(email);
      setSuccess(true);
    } catch (err) {
      console.error('Password reset error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-accent-50 via-white to-primary-50 flex flex-col">
      {/* Header */}
    <header className="bg-white shadow-sm border-b border-neutral-200 sticky top-0 z-40">

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        {/* <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <Link to="/" className="flex items-center space-x-2">
            <span className="text-3xl">💝</span>
            <span className="text-2xl font-script font-bold text-accent-600">
              SobreDigital
            </span>
          </Link> */}
        {/* </div> */}
           <Logo className="h-12 sm:h-14" />
           </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8 py-12">
        <div className="max-w-md w-full">
          <div className="bg-white rounded-2xl shadow-xl p-8 animate-scale-in">
            {!success ? (
              <>
                {/* Title */}
                <div className="text-center mb-8">
                  <div className="text-5xl mb-4">🔐</div>
                  <h2 className="text-3xl font-display font-bold text-neutral-900 mb-2">
                    ¿Olvidaste tu contraseña?
                  </h2>
                  <p className="text-neutral-600">
                    No te preocupes, te enviaremos instrucciones para recuperarla
                  </p>
                </div>

                {/* Form */}
                <form onSubmit={handleSubmit} className="space-y-6">
                  <div>
                    <label className="block text-sm font-medium text-neutral-700 mb-2">
                      Email
                    </label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      className="input-field"
                      placeholder="tu@email.com"
                    />
                  </div>

                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full btn-primary text-lg"
                  >
                    {loading ? (
                      <span className="flex items-center justify-center">
                        <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Enviando...
                      </span>
                    ) : (
                      'Enviar Instrucciones'
                    )}
                  </button>
                </form>

                {/* Back to Login */}
                <div className="mt-6 text-center">
                  <Link to="/login" className="text-accent-600 hover:text-accent-700 text-sm font-medium">
                    ← Volver a iniciar sesión
                  </Link>
                </div>
              </>
            ) : (
              <>
                {/* Success Message */}
                <div className="text-center">
                  <div className="text-6xl mb-4">✉️</div>
                  <h2 className="text-3xl font-display font-bold text-neutral-900 mb-4">
                    Email Enviado
                  </h2>
                  <p className="text-neutral-600 mb-6">
                    Si tu email está registrado, recibirás instrucciones para recuperar 
                    tu contraseña en breve.
                  </p>
                  <p className="text-sm text-neutral-500 mb-8">
                    Revisá tu casilla de correo (incluyendo spam).
                  </p>
                  <Link to="/login" className="btn-primary inline-block">
                    Volver a Iniciar Sesión
                  </Link>
                </div>
              </>
            )}
          </div>

          {/* Back to Home */}
          <div className="mt-6 text-center">
            <Link to="/" className="text-neutral-600 hover:text-neutral-900 text-sm font-medium">
              ← Volver al inicio
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ForgotPasswordPage;
